export enum Region {
	ANTWERPSE_KEMPEN = 'ANTWERPSE_KEMPEN',
	BRUGSE_OMMELAND = 'BRUGSE_OMMELAND',
	GROENE_GORDEL = 'GROENE_GORDEL',
	HAGELAND = 'HAGELAND',
	HASPENGOUW = 'HASPENGOUW',
	KUNSTSTAD_ANTWERPEN = 'KUNSTSTAD_ANTWERPEN',
	KUNSTSTAD_BRUGGE = 'KUNSTSTAD_BRUGGE',
	KUNSTSTAD_BRUSSEL = 'KUNSTSTAD_BRUSSEL',
	KUNSTSTAD_GENT = 'KUNSTSTAD_GENT',
	KUNSTSTAD_LEUVEN = 'KUNSTSTAD_LEUVEN',
	KUNSTSTAD_MECHELEN = 'KUNSTSTAD_MECHELEN',
	KUST = 'KUST',
	LEIE_STREEK = 'LEIE_STREEK',
	LIMBURGSE_KEMPEN = 'LIMBURGSE_KEMPEN',
	MAASLAND = 'MAASLAND',
	MEETJESLAND = 'MEETJESLAND',
	SCHELDELAND = 'SCHELDELAND',
	VLAAMSE_ARDENNEN = 'VLAAMSE_ARDENNEN',
	VOERSTREEK = 'VOERSTREEK',
	WAASLAND = 'WAASLAND',
	WESTHOEK = 'WESTHOEK',
}

export const REGIONS: Region[] = [
	Region.ANTWERPSE_KEMPEN,
	Region.BRUGSE_OMMELAND,
	Region.GROENE_GORDEL,
	Region.HAGELAND,
	Region.HASPENGOUW,
	Region.KUNSTSTAD_ANTWERPEN,
	Region.KUNSTSTAD_BRUGGE,
	Region.KUNSTSTAD_BRUSSEL,
	Region.KUNSTSTAD_GENT,
	Region.KUNSTSTAD_LEUVEN,
	Region.KUNSTSTAD_MECHELEN,
	Region.KUST,
	Region.LEIE_STREEK,
	Region.LIMBURGSE_KEMPEN,
	Region.MAASLAND,
	Region.MEETJESLAND,
	Region.SCHELDELAND,
	Region.VLAAMSE_ARDENNEN,
	Region.VOERSTREEK,
	Region.WAASLAND,
	Region.WESTHOEK,
];
